import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import {lazy} from 'react'
import {SuspensedView} from '../../../../routing/PrivateRoutes'
import ProductListWrapper from './product.screen'

const productBreadcrumbs: Array<PageLink> = [
  {
    title: 'Product',
    path: '/apps/product-management/products',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ProductPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='products'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={productBreadcrumbs}>Products list</PageTitle>
              <ProductListWrapper />
            </SuspensedView>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/product-management/products' />} />
    </Routes>
  )
}

export default ProductPage
